import script from "./Lookup.vue?vue&type=script&setup=true&lang=js"
export * from "./Lookup.vue?vue&type=script&setup=true&lang=js"

import "./Lookup.vue?vue&type=style&index=0&id=e8c3ae00&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8c3ae00"]])

export default __exports__